export default {
  errorsRootKey: 'invoice/invoice-config',
  resource: 'invoice/invoice-config',
  actions: ['index', 'create', 'show', 'update', 'destroy']
}
